import React from 'react';
import { colors, type, space, radius } from '../tokens';

// Stacked horizontal bar showing giving share per household member.
const ContributionShareBar = ({ segments = [], height = 16 }) => {
  const total = segments.reduce((s, x) => s + (x.value || 0), 0);
  if (total === 0) return (
    <div style={{ ...type.small, color: colors.textTertiary }}>No household gifts yet.</div>
  );

  return (
    <div>
      <div style={{
        display: 'flex',
        height,
        borderRadius: radius.pill,
        overflow: 'hidden',
        border: `1px solid ${colors.border}`,
        background: colors.surfaceInk,
      }}>
        {segments.map((seg, i) => {
          const pct = (seg.value / total) * 100;
          if (pct === 0) return null;
          return (
            <div
              key={seg.id || i}
              title={`${seg.label} · $${seg.value.toLocaleString()} (${pct.toFixed(0)}%)`}
              style={{
                width: `${pct}%`,
                background: seg.color || colors.brand,
                transition: 'width 240ms',
              }}
            />
          );
        })}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: space[3], marginTop: space[2] }}>
        {segments.map((seg, i) => {
          const pct = total ? (seg.value / total) * 100 : 0;
          return (
            <div key={seg.id || i} style={{ display: 'flex', alignItems: 'center', gap: space[2] }}>
              <div style={{
                width: 10, height: 10, borderRadius: 2,
                background: seg.color || colors.brand,
                flexShrink: 0,
              }} />
              <span style={{ ...type.small, color: colors.textSecondary }}>
                <strong style={{ color: colors.textPrimary }}>{seg.label}</strong>
                {' · '}
                {pct.toFixed(0)}%
                {seg.valueLabel && <> · {seg.valueLabel}</>}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContributionShareBar;
